var React = require('react');

function ChartArea (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M500 384a12 12 0 0 1 12 12v40a12 12 0 0 1-12 12H12a12 12 0 0 1-12-12V76a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12v308z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M390.1 164.2L480 352H96V248l86.8-144.7a12 12 0 0 1 19.9-1L288 216l84.7-56.5a12 12 0 0 1 17.4 4.7z","className":"fa-primary","key":2})]);
}

ChartArea.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = ChartArea;

ChartArea.default = ChartArea;
